import { render, staticRenderFns } from "./AccountCreateModal.vue?vue&type=template&id=3a28ee9b&"
import script from "./AccountCreateModal.vue?vue&type=script&lang=ts&"
export * from "./AccountCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports